import { ComponentPropsWithoutRef } from 'react';

interface ChevronRightIconProps extends ComponentPropsWithoutRef<'svg'> {
    size?: number | string;
}

export const ChevronRight = (props: ChevronRightIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M9.19714 8L5.31012 4.11298L6.01683 3.38943L10.6274 8L6.01683 12.6106L5.31012 11.887L9.19714 8Z"
                fill={props.color || 'currentColor'}
            />
        </svg>
    );
};
